import { getCookie } from "../utility/cookieProvider";
import {
  GET_MORE_PRINT_FEEDS,
  SET_PRINT_FEEDS_START,
  SET_PRINT_FEEDS_FAILED,
  SET_PRINT_FEEDS_FINISH,
  SET_SELECTED_GRAPH_FEED,
} from "./actionTypes";
import { APP_CONSTANTS, COOKIE, HTTP_CODES } from "../constants/app-constant";
import { envConfig, unifiedEnvConfig } from "../constants/api-endpoint";
import { httpPost } from "../utility/requestHelper";
import { REQUEST_CANCELLING_CONSTANTS } from "../constants/cancel-request-constants";

const buildParams = (data) => {
  const {
    edition_ids,
    publication_type,
    publication_id,
    client_id,
    range,
    zone,
    limit,
    tonality,
    headline,
    keywords,
    offset,
    entity,
    vertical,
    category,
    source_type,
    press_release,
    reporter,
    favourite,
    pagination = 0,
    languages
  } = data;
  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID) || null;
  const concept_email = getCookie(COOKIE.CONCEPT_USER_EMAIL) || null;
  let tempParams = {
    client_id,
    media_type: vertical,
    limit: String(limit),
    start_date: range.start,
    end_date: range.end,
    user_id: concept_uid,
    offset: String(offset),
    download: "",
    email: concept_email,
    is_client_favourite: favourite ? 1 : "",
    pagination
  };
  if (edition_ids && edition_ids.length) {
    tempParams.edition_id = edition_ids;
  }
  if (publication_type && publication_type.length) {
    tempParams.publication_type = publication_type;
  }
  if (press_release && press_release.length) {
    tempParams.press_release = press_release;
  }
  if (entity && entity.length) {
    tempParams.entities = entity;
  }
  if (tonality && tonality.length) {
    tempParams.tonality = tonality;
  }
  if (publication_id && publication_id.length) {
    tempParams.publication_id = publication_id;
  }
  if (source_type) {
    tempParams.source_type = source_type;
  }
  if (reporter) {
    tempParams.reporter = reporter;
  }
  if (headline) {
    tempParams.headline = headline;
  }
  if (keywords) {
    tempParams.keywords = keywords;
  }
  if (zone && zone.length) {
    tempParams.zone = zone;
  }
  if (category && category.length) {
    tempParams.category = category;
  }
  if (languages && languages.length) {
    tempParams.language = languages;
  }
  return tempParams;
};

export const fetchPrintFeeds = (data, isLoadMore, isInitialLoad) => {
  return (dispatch) => {
    dispatch(setPrintFeedsStart(isLoadMore));

    const params = buildParams(data);
    httpPost(
      `${envConfig.PRINT_NEWS_TO_ENTITY}`,
      params,
      {},
      true,
      REQUEST_CANCELLING_CONSTANTS.SEARCH_API
    )
      .then((res) => {
        const {
          data: { status, result, messsage },
        } = res || {};
        if (status === HTTP_CODES.SUCCESS && result && result.data) {
          dispatch(setPrintFeedsFinish(result.data));
        } else {
          dispatch(setPrintFeedsFailed(messsage));
        }
      })
      .catch((e) => {
        if (e.message == APP_CONSTANTS.API_CANCEL_ERROR_TEXT) {
          dispatch(setPrintFeedsFailed(e, true));
        } else {
          dispatch(setPrintFeedsFailed(e));
        }
      });
  };
};

export const fetchPrintFeedsByEntity = (data) => {
  return new Promise((resolve, reject) => {
    const params = buildParams(data);
    httpPost(
      `${envConfig.PRINT_NEWS_TO_ENTITY}`,
      params,
      {},
      false,
      REQUEST_CANCELLING_CONSTANTS.SEARCH_API,
      data.timeout
    )
      .then((res) => {
        const {
          data: { result },
        } = res || {};
        resolve(result.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

const setPrintFeedsStart = (isLoadMore) => {
  return {
    type: isLoadMore ? GET_MORE_PRINT_FEEDS : SET_PRINT_FEEDS_START,
  };
};

const setPrintFeedsFailed = (error, isCancelled) => {
  return {
    type: SET_PRINT_FEEDS_FAILED,
    error: isCancelled ? null : error,
    isCancelled,
  };
};

const setPrintFeedsFinish = (data) => {
  return {
    type: SET_PRINT_FEEDS_FINISH,
    data: data,
  };
};

export const fetchNewPrintFeedsByEntity = (data) => {
  return new Promise((resolve, reject) => {
    const params = buildParams(data);
    httpPost(
      `${envConfig.NEW_PRINT_NEWS_TO_ENTITY}`,
      // `${unifiedEnvConfig.PRINT_LIST_COUNT}`,
      params,
      {},
      false,
      REQUEST_CANCELLING_CONSTANTS.SEARCH_API,
      data.timeout
    )
      .then((res) => {
        const {
          data: { result },
        } = res || {};
        resolve(result.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const fetchNewPrintFeedsByEntityParams = (data) => {
  return buildParams(data);
};
